import { render, staticRenderFns } from "./CompanyTabs.vue?vue&type=template&id=401a4be6&scoped=true"
import script from "./CompanyTabs.vue?vue&type=script&lang=js"
export * from "./CompanyTabs.vue?vue&type=script&lang=js"
import style0 from "./CompanyTabs.vue?vue&type=style&index=0&id=401a4be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a4be6",
  null
  
)

export default component.exports